import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavLink, withRouter } from 'react-router-dom';
import styled, { withTheme } from 'styled-components/macro';
import Helmet from 'react-helmet';
import FixedCloseButton from '@tovia/man-ui/lib/components/FixedCloseButton/FixedCloseButton';
import LoaderWrapper from '../../components/Loader/LoaderWrapper';
import { galleryImageUrl, galleryImagePageUrl } from 'src/client/helpers/urls';
import * as imageGridActions from '../../redux/modules/imageGrid';
import urls from 'src/shared/urls';

export class ImageGridClass extends Component {
  static propTypes = {
    items: PropTypes.array,
    load: PropTypes.func.isRequired, // eslint-disable-line
    gallery: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    match: PropTypes.object.isRequired,
    site: PropTypes.object.isRequired,
    className: PropTypes.string,
    theme: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
    contentCdnUrl: PropTypes.string.isRequired,
    history: PropTypes.any.isRequired,
    location: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  };

  static defaultProps = {
    className: '',
    items: [],
    gallery: false,
  };

  componentWillMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { error, history } = nextProps;
    if (error && error.status === 404) {
      history.replace(urls.get.notFound);
    }
    this.loadData(nextProps);
  }

  loadData = (props = this.props) => {
    const {
      load,
      match: {
        params: { galleryName, date, mediaType },
      },
    } = props;

    const params = {
      name: galleryName,
      date,
      mediaFirst: 1002,
      mediaType,
    };
    load(params);
  };

  render() {
    const { items, gallery, site, className, contentCdnUrl, location } = this.props;
    const { prevPath } = location.state || {};
    const galleryPageNumber =
      this.props.match.params.galleryPageNumber && this.props.match.params.galleryPageNumber !== 'undefined'
        ? this.props.match.params.galleryPageNumber
        : 1;
    const imageNumber = this.props.match.params.imageNumber || 1;
    const searchParams = new URLSearchParams(location.search);
    const tokenQs = searchParams.has('token') ? `?token=${searchParams.get('token')}` : '';

    if (items && gallery) {
      return (
        <div className={className}>
          <Helmet>
            <title>{`${gallery.models.map((model) => model.name).join(' & ')} - "${gallery.name}" :: ${
              site.name
            }`}</title>
            <meta
              property="og:title"
              content={`${gallery.models.map((model) => model.name).join(' & ')} - "${gallery.name}" :: ${site.name}`}
            />
            <meta property="og:url" content={`https://www.${site.domain}${gallery.path}/image/grid`} />
          </Helmet>
          <div className="container">
            <div className="show-on-hover">
              <FixedCloseButton
                url={prevPath || `${gallery.path}/image/${imageNumber}${tokenQs}#galleryPage=${galleryPageNumber}`}
                scrollbarPadding
              />
            </div>
            <div className="list">
              {items.map((item) => (
                <NavLink
                  key={item.UUID}
                  to={`${galleryImagePageUrl(item, gallery)}${tokenQs}#galleryPage=${galleryPageNumber}`}
                  style={{
                    backgroundImage: `url(${galleryImageUrl(
                      gallery.UUID,
                      item.UUID,
                      gallery.siteUUID,
                      contentCdnUrl,
                    )})`,
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={className}>
        <LoaderWrapper reloadFunction={this.loadData} />
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      error: state.imageGrid.error,
      items: state.imageGrid.items,
      gallery: state.imageGrid.gallery,
      lastCallParams: state.imageGrid.lastCallParams,
      site: state.site,
      contentCdnUrl: state.app.contentCdnUrl,
    }),
    (dispatch) =>
      bindActionCreators(
        {
          load: imageGridActions.load,
        },
        dispatch,
      ),
  )(
    withTheme(styled(ImageGridClass)`
      position: fixed;
      overflow-y: auto;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: ${(props) => props.theme.primary1};
      z-index: 9999;

      @media (max-width: 767px) {
        text-align: center;
      }

      :hover {
        @media (min-width: 767px) {
          .show-on-hover {
            opacity: 1;
          }
        }
      }

      @media (min-width: 767px) {
        .show-on-hover {
          opacity: 0;
          transition: 0.3s opacity;
        }
      }

      & .list {
        margin-top: 10px;

        a {
          display: inline-block;
          margin: 0 4px 10px;
          background-size: auto 100%;
          background-position: center;
          width: 147px;
          height: 147px;
          background-repeat: no-repeat;
          background-color: transparent;
        }

        img {
          width: 147px;
          height: 147px;
        }
      }
    `),
  ),
);
